<template>
	<div class="mainApp">
		<RentsPage ref="rents_page" />
	</div>
</template>

<script>
	import RentsPage from "@/components/RentsPage.vue";

	export default {
		name: "NeighborhoodRentView",
		components: {
			RentsPage,
		},
		data() {
			return {};
		},

		mounted() {
			var appVue = this;

			appVue.$store.dispatch("loadConfig").then(async function () {
				appVue.$store.state.searchType = "NEIGHBORHOOD";
				appVue.$store.state.neighborhoodId = appVue.$route.query.id;

				appVue.mixin_fetchPageData(
					appVue,
					"NEIGHBORHOOD",
					appVue.$route.query.id,
					appVue.$store.state.config.api_base,
				);
				const d_url =
					appVue.$store.state.config.s3_page_base +
					"/neighborhood/rent/" +
					appVue.$route.query.id +
					".json";
				try {
					const response = await fetch(d_url);
					const e = await response.json();
					if (appVue.$store.state.neighborhoodName == null) {
						appVue.$store.state.neighborhoodName = e.neighborhoodName;
					}
					if (appVue.$store.state.settlementName == null) {
						appVue.$store.state.settlementName = e.settlementName;
					}
					appVue.$store.state.similarNeighborhoods = e.otherNeighborhoods;

					if (appVue.$refs.rents_page == undefined) {
						return;
					} else {
						appVue.$refs.rents_page.$refs.neigh_scroller.similarNeighborhoods =
							e.otherNeighborhoods;
						appVue.$store.state.isMain = false;
						appVue.mixin_setTrendsData(appVue, e);
					}
				} catch (error) {
					console.error("Error:", error);
					appVue.$router.push({
						name: "notfound",
						query: { view: "notfound" },
					});
				}
			});
		},
	};
</script>
